<template>
<div class="mt-3">
        <div class="row">
            <div class="col-sm-4 modspec_font14">Walls</div>
        </div>
        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <!------------------------------->
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Wall Cladding
                    </div>
                    <div class="col-sm-1 modspec_font10">Colour:</div>
                    <div class="col-sm-3">
                        <select class="form-select">
                            <option value="">Surfmist</option>
                        </select>
                    </div>
                    <div class="col-sm-1 modspec_font10">Type</div>
                    <div class="col-sm-3">
                        <select class="form-select">
                            <option value="">LW</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-2 modspec_font10">
                        <label class="form-check-label modspec_font10" for="wallBattens">Battens? </label> <input
                            class="form-check-input" id="wallBattens" type="checkbox">
                    </div>
                    <div class="col-sm-1 modspec_font10">Depth:</div>
                    <div class="col-sm-2">
                        <input type="text" class="form-control" placeholder="mm" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Insulation
                    </div>
                    <div class="col-sm-3 modspec_font10">
                        <input class="form-check-input" id="wallsSarking" type="checkbox"><label
                            class="form-check-label modspec_font10" for="wallsSarking">Sarking/Foil </label>
                    </div>
                    <div class="col-sm-3 modspec_font10">
                        <input class="form-check-input" id="wallsThermal" type="checkbox"><label
                            class="form-check-label modspec_font10" for="wallsThermal">Thermal Break </label>
                    </div>
                    <div class="col-sm-2 modspec_font10">
                        <input class="form-check-input" id="wallsBatts" type="checkbox"><label
                            class="form-check-label modspec_font10" for="wallsBatts">Batts </label>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14"></div>
                    <div class="col-sm-4 modspec_font10">
                        Sarking Description
                    </div>
                    <div class="col-sm-4 modspec_font14">
                        <input type="text" class="form-control" placeholder="i.e. Rhino Wrap" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-8"></div>
                    <div class="col-sm-2 modspec_font10">
                        <label class="form-check-label modspec_font10" for="wallsReflective">Reflective? </label> <input
                            class="form-check-input" id="wallsReflective" type="checkbox">
                    </div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">Facing</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14"></div>
                    <div class="col-sm-4 modspec_font10">
                        Thermal Break Description:
                    </div>
                    <div class="col-sm-4 modspec_font14">
                        <input type="text" class="form-control" placeholder="i.e. Aircell" />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-9"></div>
                    <div class="col-sm-1 modspec_font10">R-val</div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">1.0</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-8"></div>
                    <div class="col-sm-2 modspec_font10">
                        <label class="form-check-label modspec_font10" for="wallsReflective">Reflective? </label> <input
                            class="form-check-input" id="wallsReflective" type="checkbox">
                    </div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">Facing</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-2 modspec_font10">Batts Description</div>
                    <div class="col-sm-3"><input type="text" class="form-control" placeholder="i.e. Fletcher" /></div>
                    <div class="col-sm-1 modspec_font10">R-val</div>
                    <div class="col-sm-2">
                        <select class="form-select">
                            <option value="">1.0</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Lining:
                    </div>
                    <div class="col-sm-4">
                        <select class="form-select">
                            <option value="">As per drawings</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-2 modspec_font14">
                        Framing:
                    </div>
                    <div class="col-sm-2 modspec_font14">
                        <select class="form-select">
                            <option value="">Metal</option>
                        </select>
                    </div>
                    <div class="col-sm-1 modspec_font10">Studs:</div>
                    <div class="col-sm-1"><input type="text" class="form-control" placeholder="90" /></div>
                    <div class="col-sm-1 modspec_font10">X</div>
                    <div class="col-sm-1"><input type="text" class="form-control" placeholder="50" /></div>
                    <div class="col-sm-1 modspec_font10">X</div>
                    <div class="col-sm-1"><input type="text" class="form-control" placeholder="0.75 BMT" /></div>
                    <div class="col-sm-1 modspec_font10">Ctrs(mm)</div>
                    <div class="col-sm-1"><input type="text" class="form-control" placeholder="600" /></div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4">
                        <button class="btn btn-primary">Add Detail/Note +</button>
                    </div>
                </div>
                <!------------------------------->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "cd-wall",
    data: function () {
        return {
            wall: {  },
            //number:0
        }
    },
    mounted() {

    },
    methods: {
        test(){
            this.wall = {  };
        },

    },
}
</script>
<style></style>